export const module10InitialState = {
  module10: {
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    keys: 0,
    coins: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      UFO1: false,
      UFO2: false,
      Planet1: false,
      Planet2: false,
      Rocket1: false,
      Rocket2: false,
      CometBlue: false,
      CometOrange: false,
      Stars1: false,
      Stars2: false,
      Alien1: false,
      Alien2: false,
      Constellation1: false,
      Constellation2: false,
      Helmet1: false,
      Helmet2: false,
      NorthernLights: false,
      Galaxy: false,
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
    },
  },
};

export const Module10Reducer = (state = module10InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE10_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        UFO1: false,
        UFO2: false,
        Planet1: false,
        Planet2: false,
        Rocket1: false,
        Rocket2: false,
        CometBlue: false,
        CometOrange: false,
        Stars1: false,
        Stars2: false,
        Alien1: false,
        Alien2: false,
        Constellation1: false,
        Constellation2: false,
        Helmet1: false,
        Helmet2: false,
        NorthernLights: false,
        Galaxy: false,
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]] = true;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[], "tokens_earned":0}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"SurfBoardRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachChairRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"FloatationInnerTube\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SeashellsRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"CrabWearMustash\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module10: {
          ...state.module10,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
          coins: JSON.parse(tempObj)?.tokens_earned,
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module10InitialState,
      };
    }
    case 'MODULE10_SET_DAY': {
      return {
        ...state,
        module10: {
          ...state.module10,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE10_SET_GameDetials': {
      return {
        ...state,
        module10: {
          ...state.module10,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE10_SET_stepCompleted': {
      return {
        ...state,
        module10: {
          ...state.module10,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE10_SET_dayCompleted': {
      return {
        ...state,
        module10: {
          ...state.module10,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE10_SET_CAMERAOPEN': {
      return {
        ...state,
        module10: {
          ...state.module10,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE10_SET_KEY': {
      return {
        ...state,
        module10: {
          ...state.module10,
          keys: action.payload,
        },
      };
    }
    case 'MODULE10_SET_COIN': {
      return {
        ...state,
        module10: {
          ...state.module10,
          coins: action.payload,
        },
      };
    }
    case 'MODULE10_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module10: {
          ...state.module10,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE10_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module10: {
          ...state.module10,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE10_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module10: {
          ...state.module10,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE10_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module10: {
          ...state.module10,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE10_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module10: {
          ...state.module10,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE10_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module10: {
          ...state.module10,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE10_SET_REWARD11': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            UFO1: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD12': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            UFO2: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD21': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            Planet1: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD22': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            Planet2: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD31': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            Rocket1: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD32': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            Rocket2: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD41': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            CometBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD42': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            CometOrange: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD51': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            Stars1: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD52': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            Stars2: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD61': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            Alien1: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD62': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            Alien2: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD71': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            Constellation1: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD72': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            Constellation2: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD81': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            Helmet1: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_REWARD82': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            Helmet2: action.payload,
          },
        },
      };
    }

    case 'MODULE10_SET_PRIZE1': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            NorthernLights: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_PRIZE2': {
      return {
        ...state,
        module10: {
          ...state.module10,
          rewards: {
            ...state.module10.rewards,
            Galaxy: action.payload,
          },
        },
      };
    }

    case 'MODULE10_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module10: {
          ...state.module10,
          unlockedDays: {
            ...state.module10.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module10: {
          ...state.module10,
          unlockedDays: {
            ...state.module10.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module10: {
          ...state.module10,
          unlockedDays: {
            ...state.module10.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module10: {
          ...state.module10,
          unlockedDays: {
            ...state.module10.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module10: {
          ...state.module10,
          unlockedDays: {
            ...state.module10.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module10: {
          ...state.module10,
          unlockedDays: {
            ...state.module10.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module10: {
          ...state.module10,
          unlockedDays: {
            ...state.module10.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE10_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module10: {
          ...state.module10,
          unlockedDays: {
            ...state.module10.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }

    default:
      return state;
  }
};
export default Module10Reducer;
